const fullProject = [
  // {
  //   id: 1,
  //   name: "",
  //   type: "fullstack"      
  //   img: "",
  //   description: "",
  //   development:
  //     <>
  //     </>,
  //   challenges:
  //     <>
  //     </>,
  //   links: {
  //     app: "",
  //     repo: "",
  //   },
  //   skills: {
  //     name: [

  //     ],
  //     icon: [
        
  //     ],
  //   },
  //   demonstration: {
  //     video: "",
  //     screenshots: [
  //       ""
  //     ]
  //   },
  // },
]

export default fullProject;